import { render } from "./ClassDiagram.vue?vue&type=template&id=da158a84&scoped=true&ts=true"
import script from "./ClassDiagram.vue?vue&type=script&lang=ts"
export * from "./ClassDiagram.vue?vue&type=script&lang=ts"

import "./ClassDiagram.vue?vue&type=style&index=0&id=da158a84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da158a84"]])

export default __exports__